// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MbQaBWobkQZZTj {
  position: absolute;
  z-index: 1;
  top: 100%;
  right: 0;
  width: 255px;
  padding-top: 5px;
}
.MbQaBWobkQZZTj::after {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  right: 20px;
  width: 10px;
  height: 10px;
  transform: rotate(45deg);
  background: var(--ds-surface-overlay, #ffffff);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"interactiveTooltip": `MbQaBWobkQZZTj`
};
export default ___CSS_LOADER_EXPORT___;
